import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  data: null,
  count: null,
  error: "",
};

export default function Event(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Event.SET_DATA:
      return { ...state, data: action.data };
    case Action.Event.SET_COUNT:
      return { ...state, count: action.data };
    case Action.Event.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Event.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Event.CLEAR:
      return { ...state, ...InitialState };
    default:
      return state;
  }
}
